export const OurFutureSliderItemList = [
  {
    number: '01',
    title: '“頼れる存在”がマンションの1階に\n⽇常も、⾮⽇常も、安⼼サポート',
    contents: [
      'いつでも頼れて顔が知れてる「常駐ペットシッター」',
      '送迎楽々。散歩のついでに寄っていけるペットも馴染みやすい「⽝の保育園」',
      'ペットのセカンドハウスに。ペットと遊べる「屋内スペース」',
    ],
    images: ['featureImage01.png'],
    imagePosition: 'bothEndsDiffSize',
    imageHeight: '25.7rem',
  },
  {
    number: '02',
    title: '“分かり合える仲間”がそばにいる\nペットでつながる互助コミュニティ',
    contents: [
      'もちろんペットと一緒に。好きな時に立ち寄れる「入居者専用共用ラウンジ」',
      'ごはん、病院、お出かけ・・・ペットの情報をシェアし合おう。\n不用品のシェアや利用予約もできる「マンション専用アプリ」',
      '映画やスポーツ観戦、食事会。仲間と、ペットと一緒に。「併設シェアキッチン」',
    ],
    images: ['featureImage02.webp'],
    imagePosition: 'bothEndsDiffSize',
    imageHeight: '19rem',
  },
  {
    number: '03',
    title: 'あれもこれも！ワガママが叶う。\n安心と楽しさが詰まったサービスが充実',
    contents: [
      '留守中も安心。お部屋の温度管理も遠隔で操作できる。「IoTサービス完備」',
      'マンション内に出向いてくれる「出張トリミング」「ドッグトレーナーDAY」',
      'ペットの体調変化に気づいた時に「24時間獣医師オンライン相談」',
      '⼊居者限定！「ペット⽤品割引」',
      '最新ペットグッズの「お試し体験」「ワークショップイベント」',
      'ペットとのお出かけに！「カーシェア」「（ペット乗せ）⾃転⾞シェア」「シェアバギー」',
    ],
    images: ['featureImage06.png'],
    imagePosition: 'bothEndsDiffSize',
    imageHeight: '29.3rem',
  },
  {
    number: '04',
    title: 'ペット共⽣型マンションだから実現できる\nペットも、飼い主も、うれしい設備',
    contents: ['大型犬、多頭飼いもOK！'],
    images: ['featureImage05.png'],
    imagePosition: 'bothEndsDiffSize',
    imageHeight: '15.1rem',
    showEquipment: true,
  },
];
